export default "<div class=\"alert alert-info\">wird geladen ...</div>"